import { combineReducers } from "redux";
import { FETCH_NOTIFICATIONS_SUCCESS, FETCH_VERIFICATION_TOKEN_EXCHANGE_SUCCESS } from "./actions/portalActions";

function notifications(state = [], action) {
    switch (action.type) {
        case FETCH_NOTIFICATIONS_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}

function verificationTokenExchange(state = null, action) {
    switch (action.type) {
        case FETCH_VERIFICATION_TOKEN_EXCHANGE_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}

export default combineReducers({
    notifications,
    verificationTokenExchange
})



/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/portal/portalReducers.js
 **/